export var TextAlignment;
(function (TextAlignment) {
    TextAlignment[TextAlignment["Left"] = 0] = "Left";
    TextAlignment[TextAlignment["Center"] = 1] = "Center";
    TextAlignment[TextAlignment["Right"] = 2] = "Right";
})(TextAlignment || (TextAlignment = {}));
//# sourceMappingURL=alignment.js.map


// WEBPACK FOOTER //
// ./node_modules/pdf-lib/es/api/text/alignment.js